import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	defaultPriorityLozenge: {
		id: 'admin-pages-priority-schemes.common.default-priority-lozenge',
		defaultMessage: 'Default',
		description: 'Lozenge text for the default priority',
	},
});
